export default () => ({
  heading: {
    textAlign: 'center',
    width: '100%',
  },
});
